import React, { useState, useEffect, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
    Row,
    Button,
    Nav, TabContent, TabPane, NavItem
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_FormsList, gAPI_FormsCategoryList, API_FormSettings, gAPI_Site_Settings } from '../../../../../constants/APIs';
import { FormsList } from './components/FormsList';
import Forms from "./components/Forms";
import LanguageTabs from '../components/LanguageTabs/LanguageTabs';
import no_forms from './../../../../../assets/no_forms.png';
import FormSettings from './components/FormSettings';
import FormTemplate from './components/FormTemplate';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;
function Index({ propertyId, locale, serviceProvider, }) {
    const [activeTab, setActiveTab] = useState('forms');
    const [selectedLanguage, setSelectedLanguage] = useState(locale);
    const [loading, setLoading] = useState(true);
    const [isAdd, setIsAdd] = useState(false);
    const [formsDataList, setFormsDataList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [formSettings, setFormSettings] = useState(null);
    const [service, setService] = useState('');
    const [isImportTemp, setIsImportTemp] = useState(false);
    useEffect(() => {
        LoadData(selectedLanguage);
        fetchService(serviceProvider);
    }, [locale, serviceProvider]);
    const LoadSetting = () => {
        AxiosAPI({
            method: 'get',
            url: `${API_FormSettings}/list?groupId=${getGroupID()}&propertyId=${propertyId}`,
        }).then((res) => {
            if (res.data && res.data.type === "Form") {
                setFormSettings(res.data);
            }
        }).catch((err) => console.log('err', err));
    }
    const LoadData = (lang) => {
        setLoading(true);
        AxiosAPI({
            method: 'get',
            url: `${gAPI_FormsList}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=en`,
        })
            .then((res) => {
                console.log(res.data);
                setFormsDataList(res.data);
                setLoading(false);
            }).catch((err) => console.log('err', err));

        AxiosAPI({
            method: 'get',
            url: `${gAPI_FormsCategoryList}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${lang}`,
        }).then((res) => {
            var category = [{ label: "Add New", value: "-1" }];
            res.data.map(l => category.push(l));
            setCategoryList(category);
        });
    };
    const fetchService = (serviceProvider) => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Site_Settings}`,
        })
            .then((res) => {
                const matchedService = res.data.find(
                    (item) => item.id.toString() === serviceProvider
                );
                console.log('1208', serviceProvider, matchedService)
                if (matchedService) {
                    setService(matchedService?.dashboardUrl);

                }
            })
            .catch((err) => console.error('Error fetching service:', err));
    };
    const toggleMenu = (tab) => {
        if (tab === "settings") {
            LoadSetting();
        }
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    const handleImport = () => {
        setIsImportTemp(true);
    }
    return (
        <Fragment>
            <div className="mb-4">
                <h4><b><IntlMessages id='dashboards.createForms' /></b></h4>
                <p >  <IntlMessages id='dashboards.manageForms' /></p>
            </div>
            <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-0 mr-0">
                <style>{style_css}</style>
                <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'forms',
                            'nav-link': true,
                        })}
                        onClick={() => toggleMenu('forms')}
                    >
                        <span
                            style={{ color: `${activeTab === "forms" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
                        >
                            <IntlMessages id="forms.forms-title" />
                        </span>
                    </NavLink>
                </NavItem>
                <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'settings',
                            'nav-link': true,
                        })}
                        onClick={() => toggleMenu('settings')}
                    >
                        <span
                            style={{ color: `${activeTab === "settings" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
                        >
                            Settings
                        </span>
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="forms">
                    <Row className="app-row survey-app">
                        <Colxx xxs="12">
                            <div className="mb-2 mt-2">
                                <div className="text-zero">
                                    <Button
                                        color="primary"
                                        size="xs"
                                        outline
                                        className="mr-1"
                                        onClick={() => setIsAdd(true)}
                                    >
                                        + Create <IntlMessages id="forms.forms-title" />
                                    </Button>

                                    <Button
                                        color="primary"
                                        size="xs"
                                        outline
                                        className="mr-1"
                                        onClick={() => setIsImportTemp(true)}
                                    >
                                        Import From Templates
                                    </Button>
                                </div>
                            </div>
                        </Colxx>

                    </Row>
                    {/* <Separator className="mb-5" /> */}
                    {loading ? (
                        <div className="loading" />
                    ) : (
                        <Fragment>
                            <Row>
                                <Colxx xxs="12">
                                    {/* {formsDataList.length > 0 ?
                                        formsDataList.map((item, i) => ( */}
                                    {formsDataList.length > 0 ? (
                                        formsDataList
                                            .sort((a, b) =>
                                                a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                                            )
                                            .map((item, i) => (
                                                <FormsList
                                                    propertyId={propertyId}
                                                    item={item}
                                                    key={i}
                                                    LoadData={LoadData}
                                                    languageCode={selectedLanguage}
                                                    categoryList={categoryList}
                                                    service={service}
                                                ></FormsList>
                                            ))
                                    ) : (
                                        <Fragment>
                                            <Colxx xxs="12" className="mb-0 text-center">
                                                <img
                                                    className="w-25"
                                                    style={{ marginTop: '5rem' }}
                                                    src={no_forms}
                                                ></img>
                                            </Colxx>
                                            <Colxx xxs="12" className="mb-4 text-center">
                                                <Button
                                                    color="primary"
                                                    size="xs"
                                                    outline
                                                    className="mr-1"
                                                    onClick={() => setIsAdd(true)}
                                                >
                                                    + Create Your First{' '}
                                                    <IntlMessages id="forms.forms-title" />
                                                </Button>
                                            </Colxx>
                                        </Fragment>
                                    )}
                                </Colxx>
                            </Row>
                        </Fragment>
                    )}
                </TabPane>
            </TabContent>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="settings">
                    <FormSettings
                        settings={formSettings}
                        LoadSetting={LoadSetting}
                        locale={locale}
                    ></FormSettings>
                </TabPane>
            </TabContent>

            {isAdd && (
                <Forms
                    visible={isAdd}
                    service={service}
                    toggle={() => setIsAdd(!isAdd)}
                    formLabel={'Save'}
                    LoadData={LoadData}
                    languageCode={selectedLanguage}
                    categoryList={categoryList}
                ></Forms>
            )}
            {isImportTemp && (
                <FormTemplate
                    toggle={() => setIsImportTemp(false)}
                    visible={isImportTemp}
                    locale={selectedLanguage}
                    LoadData={LoadData}
                    propertyId={propertyId}
                ></FormTemplate>
            )}
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, serviceProvider } = settings;

    return {
        propertyId,
        locale,
        serviceProvider,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
